import { render, staticRenderFns } from "./SuportTool.vue?vue&type=template&id=67c7d727&"
import script from "./SuportTool.vue?vue&type=script&lang=js&"
export * from "./SuportTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports